// A progressive enhancement: all actions also have visible feedback.
export function selectionHaptic(browser = window) {
  if (browser.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
  try {
    browser.navigator?.vibrate?.(8);
  } catch {
    // Browser/device policy may suppress vibration even when the API exists.
  }
}
